import styled, { css } from 'styled-components'

const StyledImage = styled.img`
width: 50px;
width: ${props => props.width};
${props => props.rounded && css`
    border-radius: 50%;
    height: ${props => props.width};
`}
`

export const Image = props => {
    return <StyledImage {...props} />
}